import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const LearnFromUs = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col md:flex-row justify-between gap-6  py-8 bg-gray-50">
        {/* Disclaimer Section */}
        <div className="flex-[2] bg-white shadow-md p-6 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">
            Practical Solar and Off-Grid Training Program
          </h2>

          <p className="text-gray-700 mb-4">
            Are you passionate about learning solar installations and mastering
            the best practices in the industry? Join our comprehensive training
            program, available both online and offline, and gain the skills and
            knowledge you need to start your own solar installation business or
            enhance your existing expertise.
          </p>
          <p className="font-semibold mb-2">What You’ll Learn:</p>
          <p className="text-gray-700">Solar System Sizing</p>
          <p className="text-gray-700">
            Understand how to calculate and design the right solar system for
            different energy needs. Selecting the Right Materials
          </p>
          <p className="text-gray-700">
            Gain insights into choosing high-quality, durable components for
            optimal performance. In-Depth Knowledge of Inverters
            <br /> Learn about various types of inverters, their functions, and
            applications to suit different projects. Access to Trusted Partners
          </p>
          <br />
          <p className="text-gray-700">
            Get connected with our network of trusted dealers and suppliers for
            discounted rates and reliable materials. Real-World Applications
            <br />
            Practical, hands-on training to prepare you for real-life
            installations and troubleshooting. …and so much more to equip you
            with confidence and expertise in solar technology!
          </p>
          <br />
          <p className="font-semibold mb-2">Why Train With Us?</p>
          <p className="text-gray-700">
            <strong>Expert Guidance:</strong> Learn directly from experienced
            professionals in the field. Flexible Options: Choose between online
            or in-person sessions that fit your schedule. Business
            Opportunities: Gain the tools to start your solar business and
            access valuable industry connections. For more details or to
            register, contact us today and take the first step towards a
            brighter, energy-efficient future!
          </p>
        </div>

        {/* About Me Section */}
        <div className="flex-[1] bg-white shadow-md p-6 rounded-lg max-w-sm">
          <div className="flex flex-col items-center text-center">
            <img
              src="/Assets/man.webp" // Replace with your actual image URL
              alt="About Me"
              className="w-32 h-32 rounded-full mb-4"
            />
            <h3 className="text-lg font-bold">About Me</h3>
            <p className="text-gray-700 mt-2">
              Welcome to Solarissurge.net I'm the driving force behind this
              site, which attracts over 1,000 daily visitors interested in solar
              energy. I'm also the author of a popular solar energy book, with
              over 80,000 copies sold and more than 2,000 reviews averaging 4.5
              stars. My mission is to demystify solar power and make it
              accessible to everyone. Join me in exploring the potential of
              solar power to create a cleaner, brighter future! Link to the book
              on Amazon.{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="/aboutmesection"
              >
                Read more about me here,
              </Link>{" "}
              check out my{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="https://www.youtube.com/@odedeyidamilare"
              >
                Youtube channel
              </Link>
              , or{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="/contactsection"
              >
                send me a message.
              </Link>
            </p>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chatting.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default LearnFromUs;
